import React, { Component, Ref } from 'react'
import { Container, withPixiApp } from "@inlet/react-pixi";
import UIManager from "../../core/components/ui/UiBuilder";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { isMobile } from "react-device-detect";
import { Ilanguage } from "../../core/interface/Icommon";
import { _ReactPixi } from "@inlet/react-pixi";
import { alllanguage } from "../../data/lang/index"
import { CURRENCY } from "../../core/utills";
import winPanelListConfigurationContext from "./configuration/withwinPanelListconfiguration";
//import GridcontainerAL from "../gridcontainerAL/gridContainerAL";

import WinDropComponent from "../windropcomponent/windrop";
import { Tween } from "../../core/components/effect/tween";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { actions as winDropActions } from '../../gamereducer/winDropReducer'
import { actions as trailActions } from '../../gamereducer/trailReducer'


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IStateToProps {

}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class WinPanelListComponent extends Component<IProps, IState> {
    private app: PIXI.Application;
    protected WinPanelListContainer: _ReactPixi.IContainer | Ref<any>;
    protected displayUI: any;
    protected ui_mode: string;
    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.WinPanelListContainer = React.createRef();
        this.state = {
            uiElements: [],
            lang: "en"
        }
        if (isMobile) {
            this.ui_mode = "mobile"
        } else {
            this.ui_mode = "desktop"
        }
        this.displayUI = this.props.data.COMPONENTS[0].child.filter(this.checkUiMode.bind(this))
      
    }

    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    bindUI() {
     
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        this.layoutChange(this.props.layoutMode)
    }

    componentDidMount() {
        this.bindUI()
    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name)
            }
        });
    }

    handleEvent = (e: any) => {

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        //blastStart

        // if (nextProps.blastStart !== this.props.blastStart
        //     // || nextProps.winDropList !== this.props.winDropList
        //     // || nextProps.layoutMode !== this.props.layoutMode

        // ) {
        //     if (nextProps.blastStart && nextProps.blastStart !== this.props.blastStart) {
        //         console.log("-- Yahoo WinPanelListComponent --", nextProps.blastStart, nextProps.winDropList);
        //     }
        //     return false;

        // }
        //console.log("-- yahoo winpanelList SHD --");

        return true;
    }






    render() {
     
        let drop_component: any = [];
        for (var i = 0; i < this.props.winDropList.length; i++) {

            let PROPS_TO_SEND_WinDropComponent = {
                key: "drop_component_" + i,
                count: i,
                winDropList: this.props.winDropList,
                name: "drop_component_" + i,
                langObj: this.props.langObj,
                x: 0,
                y: 0,
                canvasApp: this.app,
                props: this.props,
                windroplistPass: [],
            }
            const RepeatCharacters = (children: any) => {
                return React.cloneElement(children)
            };
            this.props.listForStaticSymbol.push(RepeatCharacters(<WinDropComponent {...PROPS_TO_SEND_WinDropComponent}
            />))
            drop_component.push(RepeatCharacters(<WinDropComponent {...PROPS_TO_SEND_WinDropComponent}
            />));
            // this.props.listForStaticSymbol.push(<WinDropComponent {...PROPS_TO_SEND_WinDropComponent}
            // />);
     
        }
        return (
            <UIManager id={"winPanelListContainer"} name={"winPanelListContainer"} x={this.props.x} y={this.props.y} type={"Container"} ref={i => this.WinPanelListContainer = i} >
                {/* {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-winPanelList-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} ClickHandler={this.handleEvent.bind(this)} />)
                } */}
                {drop_component}
                {/* {this.props.listForStaticSymbol} */}
            </UIManager>
        );
    }
}

export default withPixiApp(connect(
    (state: Pick<IStore, 'gridsState' | 'gridStateAL' | 'winDropState' | 'applicationState'>): IStateToProps =>
    ({
        //blastStart: state.gridsState.blastStart,
        // winDropCount: state.winDropState.winDropCount,
        // spinStart: state.gridsState.spinStart,
        winDropList: state.winDropState.winDropList,
        // startWinDrop: state.winDropState.startWinDrop,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        // setWinDropCount: (): any => dispatch(winDropActions.setWinDropCount()),
        // startTrail: (): any => dispatch(trailActions.startTrail()),
        // endTrail: (): any => dispatch(trailActions.endTrail()),
        // setApplicationLayoutObject: (layoutobjectlist: string): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
    }))(winPanelListConfigurationContext(WinPanelListComponent)));